// Utility helpers for persisting the Automation Setup Wizard state.

import { setItem, getItem, removeItem } from './secureStorage';

/**
 * Shape of the data we store for the automation wizard between unauthenticated
 * redirects (e.g. landing → login/signup → back).
 */
export interface AutomationWizardState {
  website: string;
  scopes: string[];
  selectedScope: string;
}

// Single LS key to hold the whole serialized object – keeps namespace clean
const STORAGE_KEY = 'automationWizardState';

/**
 * Persist wizard state to localStorage via secureStorage helper.
 */
export function saveAutomationWizardState(state: AutomationWizardState): void {
  setItem(STORAGE_KEY, JSON.stringify(state));
}

/**
 * Load previously saved wizard state (if any).
 */
export function loadAutomationWizardState(): AutomationWizardState | null {
  const raw = getItem(STORAGE_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as AutomationWizardState;
  } catch (e) {
    console.warn('Failed to parse automation wizard state', e);
    return null;
  }
}

/**
 * Remove persisted wizard state.
 */
export function clearAutomationWizardState(): void {
  removeItem(STORAGE_KEY);
}
